import React, { useState } from 'react'
import './App.css';
import IdCard from './components/IdCard';
import Home from './components/Home';

function App() {
  const [isEnglish, setIsEnglish] = useState(
        localStorage.getItem('pageLanguage') === 'true'
    );

    const toggleLanguage = () => {
        const nextValue = !isEnglish;
        setIsEnglish(nextValue);
        localStorage.setItem('pageLanguage', nextValue);
        window.dispatchEvent(new Event("languageChange"));
    };


  return (
    <div className="container">
      <IdCard/>
      <Home/>
      <button
        onClick={toggleLanguage}
        id='Language-Button'
      >
        <p className={`tr ${!isEnglish ? 'active' : ''}`} style={{width:'min-content'}}>TR</p>
        <p className={`en ${isEnglish ? 'active' : ''}`} style={{width:'min-content'}}>EN</p>
      </button>
    </div>
  );
}

export default App;